export default "__VITE_ASSET__CbVZXXjF__"